export default function PipContainer() {
  return <div id="pip-container" className="h-0 w-0"></div>;
}
